<script>
export default {
    props: ['data', 'name'],
    name: "homeListSwiper",
    data() {
        return {
            swiperOptions1: {
                observer: true,
                observeParents: true,
                simulateTouch: false,
                loop: true,
                autoplay: {
                    delay: 5000,
                    disableOnInteraction: false,
                },
                pagination: {
                    el: '.swiper-pagination',
                },
            },
            swiperOptions2: {
                observer: true,
                observeParents: true,
                simulateTouch: false,
                loop: false,
                pagination: {
                    el: '.swiper-pagination',
                },
            },
        };
    },
    computed: {
        swiper() {
            return this.$refs.mySwiper.$swiper
        }
    },
    components: {
        
    },
    mounted() {},
    destroyed() {},
    watch: {},
    methods: {},
};
</script>

<template>
    <div class="home_list_swiper">
        <swiper class="swiper" ref="mySwiper" :options="data.length > 1 ? swiperOptions1 : swiperOptions2" v-if="data.length > 0">
            <swiper-slide v-for="(item, index) in data" :key="index">
                <template v-if="typeof item == 'object'">
                    <div class="layout_bg bg" :style="`background-image: url(${item.image});`"></div>
                    <div class="name text_shadow" v-if="name == null && item.name">{{ item.name }}</div>
                    <div class="btn" v-if="item.button_name">{{ item.button_name }}</div>
                </template>
                <div class="layout_bg bg" v-else :style="`background-image: url(${item});`"></div>
                <a :href="item.link" class="position_100" v-if="item.link"></a>
            </swiper-slide>
            <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
        <div class="name text_shadow" v-if="name">{{ name }}</div>
    </div>
</template>

<style scoped lang="scss">
.home_list_swiper{
    position: relative;
    &,
    .swiper{
        width: 100%;
        height: 100%;
    }
    .name{
        position: absolute;
        top: .1rem;
        left: .1rem;
        font-size: .18rem;
        color: #fff;
        z-index: 1;
        @media only screen and (max-width: 750px) {
            top: auto;
            left: 0;
            bottom: 2.5rem;
            width: 100%;
            font-size: .36rem;
            text-align: center;
        }
    }
    .link{
        position: absolute;
    }
    .btn{
        font-size: .22rem;
        position: absolute;
        bottom: 1.2rem;
        left: 50%;
        transform: translate(-50%, 0);
    }
    .swiper-pagination{
        display: flex;
        justify-content: center;
        gap: .1rem;
        bottom: .6rem;
        display: none;
        @media only screen and (max-width: 750px) {
            display: flex;
        }
        /deep/ .swiper-pagination-bullet{
            opacity: 1;
            margin: 0;
            width: .12rem;
            height: .12rem;
            background: none;
            border: 1px solid #fff;
            &-active{
                background: #fff;
            }
        }
    }
}
</style>